import { Button } from "@mantine/core";
import SRD_DataTable from "components/DataTable";
import React from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { getGroupSortbyIdList } from "../apis/adminGroupApis";
import { useQuery } from "react-query";
import { useState } from "react";
import { PAGE_SIZE } from "CommonData";

function GroupDataTable() {
  const navigate = useNavigate();
  const [searchParams, setSearchParams] = useSearchParams();
  const page = Number(searchParams.get("page")) || 1;

  const { data } = useQuery(["groupLists", page], () => getGroupSortbyIdList(PAGE_SIZE, page));


  const setPage = (newPage) => {
    setSearchParams({page: String(newPage)});
  };

  const columns = [
    {
  //    accessor: "index",
      accessor: "group_id",
      title: "번호",
      textAlignment: "center",
      width: 30,
  //    render: (record) => record?.rnum,
    },
    {
      accessor: "group_nm",
      title: "그룹",
      cellsStyle: {
        color: "blue",
  //      textDecoration: "underline",
      },
      /**
       * Cell을 클릭했을 때 실행하는 함수
       */
      onClick: function (e) {
        navigate(`/admin/group/${e.record.group_id}`, {state: {pg: page}});
      },
    },
    {
      accessor: "registration_date",
      title: "등록일",
    },
  ];

  const RegisterButton = () => {
    return (
      <Button variant="default" onClick={() => navigate("/admin/group/add", {state: {pg: page}})}>
        등록관리
      </Button>
    );
  };

  return (
    <SRD_DataTable
      data={data}
      columns={columns}
      registerButton={<RegisterButton />}
      page={page}
      setPage={setPage}
    />
  );
}

export default GroupDataTable;
